[
    {
        "display": "true",
        "ui_columnname": "action",
        "db_columnname": "modifiedFlag",
        "datatype": "char",
        "mappingkey": "modifiedFlag",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "true",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Exception",
        "db_columnname": "Exception_Description",
        "datatype": "String",
        "mappingkey": "Exception_Description",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Exception Type",
        "db_columnname": "Exceptiongrpname",
        "datatype": "String",
        "mappingkey": "Exceptiongrpname",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Ord Date Time",
        "db_columnname": "OrderDateTime",
        "datatype": "String",
        "mappingkey": "OrderDateTime",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order ID",
        "db_columnname": "OrderID",
        "datatype": "String",
        "mappingkey": "OrderID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Symbol",
        "db_columnname": "Symbol",
        "datatype": "String",
        "mappingkey": "Symbol",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Side",
        "db_columnname": "BuySellCode",
        "datatype": "String",
        "mappingkey": "BuySellCode",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Ord Qty",
        "db_columnname": "Quantity",
        "datatype": "Int",
        "mappingkey": "Quantity",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Ord Price",
        "db_columnname": "LimitPrice",
        "datatype": "Float",
        "mappingkey": "LimitPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trd Date Time",
        "db_columnname": "TradeDateTime",
        "datatype": "String",
        "mappingkey": "TradeDateTime",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trd Qty",
        "db_columnname": "TradeQuantity",
        "datatype": "Flaot",
        "mappingkey": "TradeQuantity",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trd Price",
        "db_columnname": "TradePrice",
        "datatype": "Float",
        "mappingkey": "TradePrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Ord Bid",
        "db_columnname": "OrdBid",
        "datatype": "Float",
        "mappingkey": "OrdBid",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Ord Ask",
        "db_columnname": "OrdAsk",
        "datatype": "Float",
        "mappingkey": "OrdAsk",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trd Bid",
        "db_columnname": "TrdBid",
        "datatype": "Float",
        "mappingkey": "TrdBid",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trd Ask",
        "db_columnname": "TrdAsk",
        "datatype": "Float",
        "mappingkey": "TrdAsk",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Capacity",
        "db_columnname": "Capacity",
        "datatype": "String",
        "mappingkey": "Capacity",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Status",
        "db_columnname": "Status",
        "datatype": "String",
        "mappingkey": "Status",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Owner",
        "db_columnname": "Owner",
        "datatype": "String",
        "mappingkey": "Owner",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Comments",
        "db_columnname": "Comments",
        "datatype": "String",
        "mappingkey": "Comments",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Price Type",
        "db_columnname": "PriceType",
        "datatype": "String",
        "mappingkey": "PriceType",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Stop Price",
        "db_columnname": "StopPrice",
        "datatype": "Float",
        "mappingkey": "StopPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Trade ID",
        "db_columnname": "TradeID",
        "datatype": "String",
        "mappingkey": "TradeID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Contra ID",
        "db_columnname": "ContraID",
        "datatype": "String",
        "mappingkey": "ContraID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Contra Acct",
        "db_columnname": "ContraAcct",
        "datatype": "String",
        "mappingkey": "ContraAcct",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Contra Broker MPID",
        "db_columnname": "ContraBrokerMPID",
        "datatype": "String",
        "mappingkey": "ContraBrokerMPID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trader Account",
        "db_columnname": "TraderAccount",
        "datatype": "String",
        "mappingkey": "TraderAccount",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "TIF",
        "db_columnname": "TimeInForce",
        "datatype": "String",
        "mappingkey": "TimeInForce",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Expiry Date",
        "db_columnname": "ExpiryDate",
        "datatype": "String",
        "mappingkey": "ExpiryDate",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Expiry Time",
        "db_columnname": "ExpiryTime",
        "datatype": "String",
        "mappingkey": "ExpiryTime",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Locate Info",
        "db_columnname": "LocateInfo",
        "datatype": "String",
        "mappingkey": "LocateInfo",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Acct. Restrict",
        "db_columnname": "AcctRestrict",
        "datatype": "String",
        "mappingkey": "AcctRestrict",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Tick Direction",
        "db_columnname": "TickDirection",
        "datatype": "String",
        "mappingkey": "TickDirection",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Not Held",
        "db_columnname": "NotHeld",
        "datatype": "String",
        "mappingkey": "NotHeld",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "DNR/DNI",
        "db_columnname": "DoNotReduceIncrease",
        "datatype": "String",
        "mappingkey": "DoNotReduceIncrease",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "AON",
        "db_columnname": "AllOrNone",
        "datatype": "String",
        "mappingkey": "AllOrNone",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Spl. Handling Code",
        "db_columnname": "SplHandlingCode",
        "datatype": "String",
        "mappingkey": "SplHandlingCode",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Delivery Instructions",
        "db_columnname": "DeliveryInstructions",
        "datatype": "String",
        "mappingkey": "DeliveryInstructions",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trade Along",
        "db_columnname": "TradeAlong",
        "datatype": "String",
        "mappingkey": "TradeAlong",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Limit Order Display",
        "db_columnname": "LimitOrderDisplay",
        "datatype": "String",
        "mappingkey": "LimitOrderDisplay",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Program Trading",
        "db_columnname": "ProgramTrading",
        "datatype": "String",
        "mappingkey": "ProgramTrading",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Negotiated Trade",
        "db_columnname": "NegotiatedTrade",
        "datatype": "String",
        "mappingkey": "NegotiatedTrade",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Strategy",
        "db_columnname": "Strategy",
        "datatype": "String",
        "mappingkey": "Strategy",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Strategy Details",
        "db_columnname": "StrategyDetails",
        "datatype": "String",
        "mappingkey": "StrategyDetails",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Trade Order ID",
        "db_columnname": "tradesOrderID",
        "datatype": "String",
        "mappingkey": "tradesOrderID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order Desk",
        "db_columnname": "OrderDesk",
        "datatype": "String",
        "mappingkey": "OrderDesk",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Originating Desk",
        "db_columnname": "OriginatingDesk",
        "datatype": "String",
        "mappingkey": "OriginatingDesk",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Received From MPID",
        "db_columnname": "ReceivedFromMPID",
        "datatype": "String",
        "mappingkey": "ReceivedFromMPID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Received Order Id",
        "db_columnname": "ReceivedOrderId",
        "datatype": "String",
        "mappingkey": "ReceivedOrderId",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Terminal User",
        "db_columnname": "TerminalUser",
        "datatype": "String",
        "mappingkey": "TerminalUser",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Cancel By Cust.",
        "db_columnname": "CancelByCust",
        "datatype": "String",
        "mappingkey": "CancelByCust",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "OMS System",
        "db_columnname": "OMSSystem",
        "datatype": "String",
        "mappingkey": "OMSSystem",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Firm MPID",
        "db_columnname": "FirmMPID",
        "datatype": "String",
        "mappingkey": "FirmMPID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Window Ask Price",
        "db_columnname": "WindowAskPrice",
        "datatype": "String",
        "mappingkey": "WindowAskPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Window Bid Price",
        "db_columnname": "WindowBidPrice",
        "datatype": "String",
        "mappingkey": "Window Bid Price",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Window Min LastPrice",
        "db_columnname": "WindowMinLastPrice",
        "datatype": "String",
        "mappingkey": "WindowMinLastPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Window Max LastPrice",
        "db_columnname": "WindowMaxLastPrice",
        "datatype": "String",
        "mappingkey": "WindowMaxLastPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Min Ask",
        "db_columnname": "MinAsk",
        "datatype": "String",
        "mappingkey": "MinAsk",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Max Bid",
        "db_columnname": "MaxBid",
        "datatype": "String",
        "mappingkey": "MaxBid",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order Price AskPrice",
        "db_columnname": "OrderPriceAskPrice",
        "datatype": "String",
        "mappingkey": "OrderPriceAskPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Order Price BidPrice",
        "db_columnname": "OrderPriceBidPrice",
        "datatype": "String",
        "mappingkey": "OrderPriceBidPrice",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    }
]